import store from '../store'
import router from '../router'

export const resolveNotificationRoute = (url = '') => {

    if (store.state.account) {
        const accountType = store.state.account.accountType
        url = url.replace(/\$account/, accountType)
    }

    router.replace(url)

}